module.exports = __webpack_public_path__ + "static/media/search.b6d385ef.svg";